/* istanbul ignore file */
export var StatusServiceEvent;
(function (StatusServiceEvent) {
    StatusServiceEvent["MessageChanged"] = "MessageChanged";
    StatusServiceEvent["PreferencesBubbleCountChanged"] = "PreferencesBubbleCountChanged";
})(StatusServiceEvent || (StatusServiceEvent = {}));
